import { withDependencies } from '@wix/thunderbolt-ioc'
import { ScrollToAnchorHandlerProviderSymbol } from '../symbols'
import type { ISamePageScroll, IScrollToAnchorHandlerProvider } from '../types'

export const samePageScrollFactory = ({ getHandler }: IScrollToAnchorHandlerProvider): ISamePageScroll => {
	return {
		scrollToAnchor: getHandler(),
	}
}

export const SamePageScroll = withDependencies([ScrollToAnchorHandlerProviderSymbol], samePageScrollFactory)
